import React from 'react';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BASE_URL } from '../../../shared/constants';
import CatalogDiscountBadge from '../../CatalogDiscountBadge';

const FavoriteProductItem = ({ product, productIdsInCart, onRemoveFromFavorites, onToggleModal, onAddToCart }) => {
  const renderPrice = (product) => {
    if (product.state === 'SOLD_OUT' && product.quantity === 0) {
      return null;
    }
    if (product.discountedPrice && product.discountedPrice < product.price) {
      return (
        <h5 className='price text-center mb-2'>
          <strike style={{ textDecoration: 'line-through', color: 'red' }}>{product.price}</strike>{' '}
          {product.discountedPrice}грн
        </h5>
      );
    } else {
      return <h5 className='price text-center mb-2'>{product.price} грн</h5>;
    }
  };

  const renderBuyButton = (product) => {
    if (productIdsInCart.includes(product.id) && product.quantity > 0) {
      return (
        <button type='button' className='btn btn-dark' onClick={onToggleModal}>
          Оформити
        </button>
      );
    }
    if (productIdsInCart.includes(product.id) && product.quantity === 0) {
      return (
        <button type='button' className='btn btn-secondary' onClick={onToggleModal}>
          Оформити
        </button>
      );
    }
    if (product.quantity > 0 && !productIdsInCart.includes(product.id)) {
      return (
        <button
          type='button'
          onClick={() => onAddToCart(product, 1)}
          className='btn btn-outline-dark'
        >
          В кошик
        </button>
      );
    }
  };

  return (
    <div className='col-xl-4 col-lg-4 col-md-6 col-12 p-2'>
      <div className='product'>
        {product.imagePathList && product.imagePathList.length > 0 && (
          <div className='product-image-block' style={{ position: 'relative' }}>
            <CatalogDiscountBadge product={product} />
            <OverlayTrigger
              placement='top'
              overlay={<Tooltip id={`tooltip-remove-${product.id}`}>Прибрати з обраного</Tooltip>}
              delay={{ show: 0, hide: 0 }}
            >
              <button
                type='button'
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onRemoveFromFavorites(product.id);
                }}
                className='btn p-0 border-0 bg-transparent'
                style={{
                  position: 'absolute',
                  top: '20px',
                  right: '20px',
                  width: '28px',
                  height: '28px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  zIndex: 10,
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(220, 53, 69, 0.9)';
                  e.currentTarget.style.transform = 'scale(1.1)';
                  e.currentTarget.style.opacity = '0.7';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.opacity = '1';
                }}
              >
                <i className='bi bi-x' style={{
                  color: '#dc3545',
                  fontSize: '1.05rem',
                  WebkitTextStroke: '0.5px #dc3545',
                  textShadow: '0.5px 0 0 #dc3545, -0.5px 0 0 #dc3545, 0 0.5px 0 #dc3545, 0 -0.5px 0 #dc3545'
                }}></i>
              </button>
            </OverlayTrigger>
            <Link className='btn-block reset-a' to={'/product/' + product.id}>
              <img
                className='product_image'
                src={`${BASE_URL}/api/v1/product/image/${product.imagePathList[0]}?height=600&width=600`}
                alt={product.name}
              />
            </Link>
          </div>
        )}
        {product.name && (
          <div className='product-name-block'>
            <Link className='btn-block reset-a' to={'/product/' + product.id}>
              <div className='product-name'>{product.name}</div>
            </Link>
          </div>
        )}
        {renderPrice(product)}
        <div className='text-center justify-content-center align-items-center row' style={{ gap: '0.5rem' }}>
          {renderBuyButton(product)}
        </div>
      </div>
    </div>
  );
};

export default FavoriteProductItem;
